import React from "react";
import { PanGestureHandlerGestureEvent } from "react-native-gesture-handler";
import { SharedValue } from "react-native-reanimated";
import { SpringConfig } from "react-native-reanimated/lib/typescript/reanimated2/animation/springUtils";

export enum ItemTypes {
  Draggable = "draggable",
  Sortable = "sortable",
}

export type ID = string;

export type CommonItem = {
  id: ID;
};

export type DragItem<T = any> = CommonItem & {
  id: ID;
  type: ItemTypes.Draggable;
  data: T;
};

export type SortItem<T = any> = CommonItem & {
  type: ItemTypes.Sortable;
  data?: T;
};

export type DragHandleProps = {
  DragHandleContainer: (props: React.PropsWithChildren<{}>) => JSX.Element;
  DragHandleComponent: React.ForwardRefExoticComponent<any>;
};

export type SortProps = {
  id: ID;
  order: SharedValue<ID[]>;
  itemWidth: number;
  itemHeight: number;
  margin: number;
  numColumns: number;
  offsetX: number;
  offsetY: number;
  springConfig?: SpringConfig;
};

export type SortContext = Record<string, any> & {
  droppedId: ID;
  order: SharedValue<ID[]>;
};

/**
 * A function that takes a context and a new order position and updates the order
 */
export type SortingStrategy = (
  ctx: SortContext,
  newOrderPosition: number
) => ID[];

export type UpdatePanHandler = {
  activeEventHandler: (e: PanGestureHandlerGestureEvent) => void;
};

export enum ScrollState {
  ScrollingDown,
  ScrollingUp,
  NotScrolling,
}
